import { useState } from "react";
import Seo from "../components/Seo";
import EventCard from "../components/EventCard";
import { LoadingState, ErrorState, EmptyState } from "../components/StateBlocks";
import useEvents from "../hooks/useEvents";

export default function Events() {
  const [scope, setScope] = useState("upcoming");
  const { events, loading, error } = useEvents(scope);

  return (
    <>
      <Seo
        title="Events"
        description="See upcoming and past HS Library Hangout board game gatherings for homeschooled high schoolers."
      />
      <h1>Events</h1>

      <div role="group" aria-label="Filter events" className="form-field">
        <button
          type="button"
          className={`btn ${scope === "upcoming" ? "btn-primary" : "btn-secondary"}`}
          onClick={() => setScope("upcoming")}
          aria-pressed={scope === "upcoming"}
        >
          Upcoming
        </button>{" "}
        <button
          type="button"
          className={`btn ${scope === "past" ? "btn-primary" : "btn-secondary"}`}
          onClick={() => setScope("past")}
          aria-pressed={scope === "past"}
        >
          Past
        </button>
      </div>

      {loading && <LoadingState label="Loading events\u2026" />}
      {error && <ErrorState message={error} />}
      {!loading && !error && events.length > 0 && (
        <div className="card-grid">
          {events.map((event) => (
            <EventCard key={event.eventId} event={event} />
          ))}
        </div>
      )}
      {!loading && !error && events.length === 0 && (
        <EmptyState title={scope === "upcoming" ? "No upcoming events yet" : "No past events yet"}>
          <p>Check back soon for new gatherings.</p>
        </EmptyState>
      )}
    </>
  );
}
